import { type ServiceMethod } from '@/application/interfaces/service';

type Body = { zip_code: string };

type Params = {
  cartId: string;
};

export type Data = Params & Body;

export type Modality = {
  cost: number;
  deadline: number;
  deadlineMessage: string;
  deadlinePrefix: string;
  type: string;
};

export type Item = {
  id: string;
  productId: number;
  storeId: string | null;
  externalId: number;
  name: string;
  skuId: string | null;
  quantity: number;
  discountByPaymentMethod: number | null;
  price: {
    to: number;
    from: number;
    discount: number;
    total: number;
    feature_installment_discount: boolean;
  };
  thumbUrl: string;
  productUrl: string;
  packaging: number;
  packagingCount: number;
  packagingUnitLabels: {
    singular: string;
    plural: string;
  };
  translatedUnit: string;
  unit: string;
  shopName: string;
  brand: string;
  categoryTree: string;
  isExpressDelivery: boolean;
  expressDeliveryDay: string;
  isSoldOut: boolean;
  hasVariants: boolean;
  origin: string;
};

export type Shipment = {
  shipment_id: string;
  modalities: Modality[];
  items: Item[];
};

export type RelatedProduct = {
  id: string;
  productId: number;
  name: string;
  skuId: string;
};

export type Service = {
  id: string;
  serviceUrl: string;
  serviceId: number;
  name: string;
  serviceBankName: string;
  quantity: number;
  packaging: number;
  packagingCount: number;
  price: {
    from: number;
    to: number;
    total: number;
  };
  relatedProduct: RelatedProduct | [];
  uniqueProductsCount: number;
};

export type Shipping = {
  type: 'delivery' | 'pickupInStore';
  storeId: string | null;
  storeName: string;
  shipments: Shipment[];
  services: Service[];
  cartRegion: string;
  cartRegionFormatted: string;
  total: number;
  cheapestPayMethodTotal: number;
  discountTotal: number;
  paymentMethods: any;
  totalInstallments: {
    amount: number;
    value: string;
    totalPrice: string;
  };
  totalDiscountsByType: any[];
  firstCheapestPaymentMethod: any;
};

export type CartShipmentData = {
  region: {
    id: string;
    name: string;
  };
  warnings: {
    change_modality_options: string[];
  };
  id: string;
  subTotal: number;
  servicesSubTotal: number;
  freightCost: number;
  canBePurchased: boolean;
  uniqueProductsCount: number;
  zipCode: string;
  shippings: Shipping[];
  services: any[];
  cartRegion: string;
  cartRegionFormatted: string;
  total: number;
  cheapestPayMethodTotal: number;
  discountTotal: number;
  paymentMethods: any;
  totalInstallments: {
    amount: number;
    value: string;
    totalPrice: string;
  };
  totalDiscountsByType: any[];
  firstCheapestPaymentMethod: any;
};

export type Response = {
  data: CartShipmentData;
};

const getCartShipments: ServiceMethod<Response, Data> =
  (httpClient) => async (data, options) => {
    const { cartId, zip_code } = data;

    const { body: response } = await httpClient.post<Response, Body, Params>(
      '/api/v3/carts/{cartId}/shipments',
      {
        ...options,
        body: {
          zip_code: zip_code, // TODO: vai ser modificado mais pra frente
        },
        params: {
          cartId,
        },
      }
    );

    return response;
  };

export default getCartShipments;
